import { TableConfigV2 } from 'hooks/useMuiTableBuilderV2';

// Data cells
import { TeamMemberAccountIdCell } from './DataCells/TeamMemberAccountIdCell';
import { TeamMemberNameCell } from './DataCells/TeamMemberNameCell';
import { TeamMemberCheckboxCell } from './DataCells/TeamMemberCheckboxCell';
import { TeamMemberCheckboxHeaderCell } from './DataCells/TeamMemberCheckboxHeaderCell';
import { TeamMemberEmailCell } from './DataCells/TeamMemberEmailCell';
import { TeamMemberRoleCell } from './DataCells/TeamMemberRoleCell';
import { TeamMemberLastActiveCell } from './DataCells/TeamMemberLastActiveCell';
import { TeamMemberIsActiveCell } from './DataCells/TeamMemberIsActiveCell';
import { TeamMemberSignInStatusCell } from './DataCells/TeamMemberSignInStatusCell';
import { TeamMemberImpersonateCell } from './DataCells/TeamMemberImpersonateCell';
import { TeamMemberCopyCell } from './DataCells/TeamMemberCopyCell';

// Header cells
import { HeaderCell } from 'components/Cells/HeaderCell';
import { getColumns, Columns } from './columns';
import { EmptyCell } from 'components/Cells/EmptyCell';

export const ROW_TYPES = {
  HEADER: 'HEADER',
  DATA: 'DATA',
};

export const getTableConfig = ({
  showSignInStatus,
}: {
  showSignInStatus: boolean;
}): TableConfigV2 => {
  const tableConfig = {
    /* --------------------------------- Shared --------------------------------- */
    hasStickyHeader: true,
    tableHeaderTitle: 'Member',
    rowTypes: ROW_TYPES,
    hideToolbar: true,
    columnsMinWidth: {
      [Columns.Checkbox]: 40,
      [Columns.Copy]: 30,
    },
    columns: getColumns({ showSignInStatus }),
    cellsByRowTypesAndColumns: {
      [ROW_TYPES.DATA]: {
        [Columns.Checkbox]: TeamMemberCheckboxCell,
        [Columns.Copy]: TeamMemberCopyCell,
        [Columns.Impersonation]: TeamMemberImpersonateCell,
        [Columns.AccountId]: TeamMemberAccountIdCell,
        [Columns.Name]: TeamMemberNameCell,
        [Columns.Email]: TeamMemberEmailCell,
        [Columns.Role]: TeamMemberRoleCell,
        [Columns.LastActive]: TeamMemberLastActiveCell,
        [Columns.IsActive]: TeamMemberIsActiveCell,
        [Columns.SignInStatus]: TeamMemberSignInStatusCell,
      },
      [ROW_TYPES.HEADER]: {
        [Columns.Checkbox]: TeamMemberCheckboxHeaderCell,
        [Columns.Copy]: EmptyCell,
        [Columns.Impersonation]: EmptyCell,
        [Columns.AccountId]: HeaderCell,
        [Columns.Name]: HeaderCell,
        [Columns.Email]: HeaderCell,
        [Columns.Role]: HeaderCell,
        [Columns.LastActive]: HeaderCell,
        [Columns.IsActive]: HeaderCell,
        [Columns.SignInStatus]: HeaderCell,
      },
    },
  } as TableConfigV2;

  return tableConfig;
};
